import Icon from '@atoms/Icon/Icon';
import clsx from 'clsx';
import { ChangeEventHandler, forwardRef } from 'react';

import styles from './CheckboxInput.module.scss';

interface Props {
  id: string;
  name: string;
  label: string;
  value: string;
  checked: boolean;
  className?: string;
  indeterminate?: boolean;
  onChange: ChangeEventHandler<HTMLInputElement>;
  noBorder?: boolean;
  noShadow?: boolean;
}

const CheckboxInput = forwardRef<HTMLInputElement, Props>(
  (
    {
      id,
      name,
      label,
      value,
      checked,
      className,
      indeterminate,
      onChange,
      noBorder,
      noShadow,
    }: Props,
    ref,
  ) => (
    <div
      className={clsx(styles.checkbox, className, {
        [styles.noBorder]: noBorder,
        [styles.noShadow]: noShadow,
      })}
    >
      <input
        className={clsx(styles.input, 'u-visually-hidden')}
        type="checkbox"
        name={name}
        value={value}
        id={id}
        checked={checked}
        onChange={onChange}
        ref={ref}
      />

      <label htmlFor={id} className={styles.labelWrapper}>
        <span className={styles.indicator}>
          <Icon
            icon={indeterminate ? 'MINUS' : 'CHECK'}
            className={styles.icon}
          />
        </span>
        <span className={styles.label}>{label}</span>
      </label>
    </div>
  ),
);

CheckboxInput.displayName = 'CheckboxInput';

export default CheckboxInput;
